import type { ApolloError } from '@apollo/client/core'

function isApolloError(error: unknown): error is ApolloError {
  return error instanceof Error && Array.isArray((error as ApolloError).graphQLErrors)
}

function getRejectedMutationErrors(reason: unknown): string[] {
  if (isApolloError(reason) && reason.graphQLErrors.length) {
    return reason.graphQLErrors.map(({ message }) => message).filter(Boolean)
  }

  if (reason instanceof Error && reason.message) return [reason.message]
  if (typeof reason === 'string' && reason) return [reason]

  return ['']
}

export default function getSettledMutationErrors<T>(
  response: PromiseSettledResult<T | null | undefined>,
  getMutationErrors: (value: T) => string[] | null | undefined,
): string[] | undefined {
  if (response.status === 'fulfilled') {
    if (!response.value) return undefined

    const errors = getMutationErrors(response.value)
    return errors?.length ? errors : undefined
  }

  return getRejectedMutationErrors(response.reason)
}
